import styles from './style.module.scss';
import { getIconUrl } from '../../lib/cdn-icon-url';
import { ImgComponent } from '../components/img-component';

interface IProps {
  readonly featuresConfig: {
    readonly iconUrl: string;
    readonly ality: string;
    readonly desc: string;
  };
}

export const ProductsFeatures = (props: IProps) => {
  return (
    <div className={styles.productsFeaturesItemBox}>
      <ImgComponent
        key={props.featuresConfig?.iconUrl || ''}
        url={getIconUrl(props.featuresConfig?.iconUrl || '')}
        className={styles.featuresItemIcon}
      />
      <div className={styles.featuresItemAlity}>
        {props.featuresConfig?.ality || ''}
      </div>
      <div className={styles.featuresItemDesc}>
        {props.featuresConfig?.desc || ''}
      </div>
    </div>
  );
};
